<template>
  <v-layout column class="_testimonial">
    
    <v-flex>
      <h2 class="text-xs-center _testimonial--title">Testimonials</h2>
    </v-flex>

    
    <v-flex>
      <app-container-review class="w--max--800">
        <app-window-base :items="items" key="test">
          <template slot="item" slot-scope="{ item }">
            <v-layout>
              <app-card-review :item="item" :key="`card-review-${item.id}`" />
            </v-layout>
          </template>
        </app-window-base>
      </app-container-review>
    </v-flex>

    
    <!-- <div class="text-center my-8">
      <h2 class="featured-heading ml-4">Proud to partner with</h2>

      <div class="partnership-carousel-container">
        <div
          ref="carouselScrollDiv"
          class="partnership-carousel-wrapper"
          @mouseenter="pauseAutoScroll"
          @mouseleave="resumeAutoScroll"
        >
          <div class="carousel-track" :style="{ transform: `translateX(${scrollPosition}px)` }">
            
            <v-card
              v-for="(partner, index) in partners2"
              :key="`first-${index}`"
              class="mx-4 d-flex align-center justify-center no-border-card carousel-item"
              width="170"
              height="100"
              elevation="0"
            >
              <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
            </v-card>
            
            
            <v-card
              v-for="(partner, index) in partners2"
              :key="`second-${index}`"
              class="mx-4 d-flex align-center justify-center no-border-card carousel-item"
              width="170"
              height="100"
              elevation="0"
            >
              <v-img :src="partner.icon" :alt="partner.name" contain class="carousel-image" />
            </v-card>
          </div>
        </div>
      </div> -->
    <!-- </div> -->
  </v-layout>
</template>

<script>
import AppCardReview from '../../../../components/app-card/app-card-review'
import AppWindowBase from '../../../../components/app-windows/app-window-base'
import AppContainerReview from '../../../../components/app-container-review'

export default {
  name: 'app-home-testimonials',

  components: {
    AppCardReview,
    AppWindowBase,
    AppContainerReview,
  },

  data() {
    return {
      partners2: [
        { name: 'Bandt', icon: require('@/assets/img/jobs.png') },
        { name: 'Embed', icon: require('@/assets/img/embed.png') },
        { name: 'XYZ', icon: require('@/assets/img/liznable.png') },
        { name: 'ABC', icon: require('@/assets/img/Group42.png') },
        { name: 'MNO', icon: require('@/assets/img/image8.png') },
        { name: 'Bandt', icon: require('@/assets/img/jobs.png') },
        { name: 'Embed', icon: require('@/assets/img/embed.png') },
        { name: 'XYZ', icon: require('@/assets/img/liznable.png') },
        { name: 'ABC', icon: require('@/assets/img/Group42.png') },
        { name: 'MNO', icon: require('@/assets/img/image8.png') },
        
      ],
      autoScrollInterval: null,
      scrollPosition: 0,
      scrollSpeed: 1,
      itemWidth: 202, 
      isPaused: false,
    }
  },

  computed: {
    items() {
      return this.$store.getters['page/testimonials']
    }
  },

  created() {
    this.$store.dispatch('page/GET_TESTIMONIALS', { path: 'forhome' })
  },

  mounted() {
    // Initialize scroll position to start from the leftmost position of duplicated items
    this.scrollPosition = -(this.partners2.length * this.itemWidth)
    this.startAutoScroll()
  },

  beforeDestroy() {
    this.stopAutoScroll()
  },

  methods: {
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        if (!this.isPaused) {
          // Move from left to right (increase scrollPosition towards 0)
          this.scrollPosition += this.scrollSpeed
          
          // Reset position when we reach the end (scrollPosition >= 0)
          if (this.scrollPosition >= 0) {
            this.scrollPosition = -(this.partners2.length * this.itemWidth)
          }
        }
      }, 12) // ~60fps
    },

    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval)
        this.autoScrollInterval = null
      }
    },

    pauseAutoScroll() {
      this.isPaused = true
    },

    resumeAutoScroll() {
      this.isPaused = false
    },
  },
}
</script>

<style lang="stylus" scoped>
._testimonial
  min-height 500px
  margin-bottom 20px

  &--title
    margin-top 80px
    @media (min-width: 960px)
      margin-top 33px

._review-container
  padding: 10px

.w--max--800
  max-width 800px !important
  margin 0 auto

.featured-heading
  font-size 24px
  font-weight bold
  color #444
  margin-bottom 20px

.partnership-carousel-container
  max-width 100%
  overflow hidden
  margin 20px 0

.partnership-carousel-wrapper
  width 100%
  overflow hidden
  position relative
  height 120px

.carousel-track
  display flex
  align-items center
  transition none
  will-change transform

.carousel-item
  flex-shrink 0

.carousel-image
  height 100px
  width auto
  max-width 120px
  transition all 0.3s ease

.carousel-item:hover .carousel-image
  transform scale(1.5)

.no-border-card
  box-shadow none !important
  border none !important
  background-color transparent !important

/* Optional: Add subtle animation */
@keyframes float
  0%, 100%
    transform translateY(0px)
  50%
    transform translateY(-2px)

.carousel-item:hover
  animation float 2s ease-in-out infinite
</style>


// WEBPACK FOOTER //
// src/views/app/home/components/app-home-testimonials.vue